import { jsx as _jsx } from "react/jsx-runtime";
import { getTestIds } from 'seagull/utils/TestIds';
import { PdfViewerModal } from '~/components/PdfViewerModal/pdfViewerModal';
import RichTextViewerModal from '~/components/RichTextViewerModal';
import { useOverlayContext } from '~/contexts';
import { handleRequest } from '~/infra/utils';
import { useStoreActions } from '~/store/store-context';
import { QuillViewerModal } from '../QuillViewerModal/QuillViewerModal';
function removePDFsuffix(name) {
    if (name === null || name === void 0 ? void 0 : name.toLowerCase().endsWith('.pdf')) {
        return name.slice(0, -4);
    }
    return name;
}
export const { UseViewLegalTermsTID } = getTestIds();
export const useViewLegalTerms = function useViewLegalTerms() {
    let { vendorBusinessId } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const overlayContext = useOverlayContext();
    return {
        async viewLegalTerms (selectedOption, sourceId) {
            const { name, pdfUniqueName, richTextContent, richTextId } = selectedOption;
            if (!name) return;
            if (pdfUniqueName) {
                await overlayContext.showModal({
                    content: (param)=>{
                        let { dismissModal } = param;
                        return /*#__PURE__*/ _jsx(PdfViewerModal, {
                            testId: UseViewLegalTermsTID.PdfViewerModal(),
                            title: removePDFsuffix(name),
                            getFileUrl: async ()=>await api.business.getLegalTermsDownloadURL(pdfUniqueName, vendorBusinessId),
                            onClose: dismissModal,
                            pdfUniqueName: pdfUniqueName
                        });
                    }
                });
            } else if (selectedOption.contentType === 'quill' && (richTextContent || richTextId)) {
                let quillContent = richTextContent;
                if ((!quillContent || quillContent.length === 0) && sourceId && richTextId) {
                    const result = await handleRequest(api.texts.getLegalTermsRichTextContent(sourceId, richTextId));
                    if (!result.success) {
                        overlayContext.showErrorToast('Failed to load document content.');
                        return;
                    }
                    quillContent = result.data.value;
                }
                if (!quillContent || quillContent.length === 0) return;
                await overlayContext.showModal({
                    content: (param)=>{
                        let { dismissModal } = param;
                        return /*#__PURE__*/ _jsx(QuillViewerModal, {
                            testId: UseViewLegalTermsTID.QuillViewerModal(),
                            title: name,
                            richTextContent: quillContent,
                            onClose: dismissModal
                        });
                    }
                });
            } else if (richTextContent || richTextId) {
                await overlayContext.showModal({
                    content: (param)=>{
                        let { dismissModal } = param;
                        return /*#__PURE__*/ _jsx(RichTextViewerModal, {
                            show: true,
                            title: removePDFsuffix(name),
                            text: richTextContent,
                            queryKey: richTextId !== null && richTextId !== void 0 ? richTextId : undefined,
                            fetchText: async ()=>{
                                if (sourceId && richTextId) {
                                    const { value } = await api.texts.getLegalTermsRichTextContent(sourceId, richTextId);
                                    return value;
                                }
                                return richTextContent;
                            },
                            onClose: dismissModal
                        });
                    }
                });
            }
        }
    };
};
